import { IButtonProps, PrimaryButton } from "@fluentui/react";
import { Values } from "@oursky/react-messageformat";
import cntl from "cntl";
import React from "react";

import { useLocale } from "../../contexts/locale";

export interface DestroyButtonProps extends IButtonProps {
  textId?: string;
  textValues?: Values;
}

export function DestroyButton(props: DestroyButtonProps) {
  const { localized } = useLocale();
  const { className, textId, textValues, text, ...restProps } = props;

  const label = textId ? localized(textId, textValues) : text;

  const customStyles = {
    root: {
      whiteSpace: "nowrap",
    },
  };

  const classes = cntl`
    ${className}
    text-white
    border-none 
    border-0
    bg-[#e13d3d]
    hover:bg-[#bd1c1c]
    hover:border-none
    hover:border-0
    active:bg-[#991b1b]
    active:border-none
    active:border-0
    disabled:bg-[#9ca3af]
    disabled:text-[#e5e7eb]
  `;
  return (
    <PrimaryButton
      className={classes}
      text={label}
      styles={customStyles}
      {...restProps}
    />
  );
}
